module.exports = __webpack_public_path__ + "media/images/wedding/thumb/26-09ef965a0b453132d502019c08a10d14.jpg";